module.exports = __webpack_public_path__ + "img/personale.f884a203.svg";